import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faPrint, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import PDFQuotations from './PDFQuotations';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        filename: '',
        arrayResult: [],
        quotationData: []
    }
    deleteRecords = (id) => {
        Swal.fire({
            title: 'Are you sure to Delete the Quotation?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Delete',
            denyButtonText: `Cancel`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("quotations/delete/" + id)
                    .then((dataResult) => {
                        console.log(dataResult);
                        Swal.fire('Deleted!', dataResult.data.msj, 'success')
                        this.ListarArrayResult(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Canceled', '', 'info')
            }
        })
    };
    ListarArrayResult(page) {
        Swal.showLoading();
        let bname = document.getElementById('bname').value;
        if (bname == '') {
            bname = 0;
        }
        authAxios.get("quotations/index/" + bname + "?page=" + page)
            .then((dataResult) => {
                console.log(dataResult);
                Swal.close();
                var status = dataResult.data.status;
                if (status) {
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    arrayResult: dataResult.data.data,
                    page: dataResult.data.total,
                    last: dataResult.data.last_page,
                    current: dataResult.data.current_page
                });
            })
            .catch(console.log);
    }
    previewPDFQuotations = (id_quotation) => {
        authAxios.get(`quotations/generate_quotation/${id_quotation}`)
            .then((dataResult) => {
                console.log(dataResult);
                var status = dataResult.data.status;
                if (!status) {
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }         
                const filename = `TC Transport - Quotation #${dataResult.data.quotation.ID_QUOTATION}.pdf`
                this.setState({
                    quotationData: dataResult.data,
                    filename: filename
                });
            })
            .catch((error) => console.log(error))
    }
    componentDidMount() {
        this.ListarArrayResult(1);
    }
    render() {
        const { load, filename, arrayResult, quotationData, page, last, current } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br/>
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddQuotations"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Add Quotations</Link>
                        </div>
                        <div className="card-body">
                            <h4>Quotations List</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-4">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bname" name="bname" placeholder="Search for Client Name" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarArrayResult(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filter</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-xl-12">
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th className="align-middle">QUOTATION ID</th>
                                                <th className="align-middle">CLIENT</th>
                                                <th className="align-middle">ADDRESS</th>
                                                <th className="align-middle">EMAIL</th>
                                                <th className="align-middle">DUE DATE</th>
                                                <th className="align-middle">VALID UNTIL</th>
                                                <th className="align-middle">TOTAL</th>
                                                <th className="align-middle">STATUS</th>
                                                <th className="align-middle">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {
                                                arrayResult.map((itemArrayResult) => (
                                                    <tr key={itemArrayResult.ID_QUOTATION}>
                                                        <td>{itemArrayResult.ID_QUOTATION}</td>
                                                        <td>{itemArrayResult.NAME}</td>
                                                        <td>{itemArrayResult.ADDRESS}</td>
                                                        <td>{itemArrayResult.EMAIL}</td>
                                                        <td>{itemArrayResult.QUOTATION_DATE}</td>
                                                        <td>{itemArrayResult.DUE_DATE}</td>
                                                        <td><b>$ </b>{currencyFormat(itemArrayResult.TOTAL)}</td>
                                                        {
                                                            (() => {
                                                                switch (itemArrayResult.STATUS) {
                                                                    case 1:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase', backgroundColor: '#00539B' }} className="badge">IN PROCESS</span></td>)
                                                                    case 2:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">APPROVED</span></td>)
                                                                    case 3:
                                                                        return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">CANCELED</span></td>)
                                                                }
                                                            })()
                                                        }
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <Link
                                                                    className="btn btn-primary btn-sm"
                                                                    to={"/UpQuotations/" + itemArrayResult.ID_QUOTATION}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </Link>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() =>
                                                                        this.deleteRecords(itemArrayResult.ID_QUOTATION)
                                                                    }
                                                                    disabled={
                                                                        itemArrayResult.STATUS === 1 ? false :
                                                                        itemArrayResult.STATUS === 2 ? true :
                                                                        itemArrayResult.STATUS === 3 ? true : ""
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </button>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary btn-sm"
                                                                    data-bs-toggle='modal'
                                                                    data-bs-target="#PDFQuotationsModal"
                                                                    slot='end'
                                                                    onClick={() => {
                                                                        this.previewPDFQuotations(itemArrayResult.ID_QUOTATION)
                                                                    }}
                                                                    disabled={
                                                                        itemArrayResult.STATUS === 1 ? true :
                                                                        itemArrayResult.STATUS === 2 ? false :
                                                                        itemArrayResult.STATUS === 3 ? true : ""
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faPrint} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(current - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={current}><a className="page-link" href="#" onClick={() => this.ListarArrayResult(current)}>{current}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(current + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(last)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Page</b> <span className="badge bg-primary">{current}</span> <b>of</b> <span className="badge bg-primary">{last}</span> | <b>Records</b> <span className="badge bg-success">{page}</span>
                        </div>
                    </div>
                </div>
                {/* Modals */}
                <div className="modal fade" id="PDFQuotationsModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PDFQuotationsModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className='col-9'>
                                    <h4 className="modal-title w-100 text-center" id="">Quotation</h4>
                                </div>
                                <div className='col-2'>
                                    <PDFDownloadLink
                                        document={<PDFQuotations data={quotationData} />}
                                        fileName={filename}
                                    >
                                        {({ loading }) =>
                                            loading ? "Loading..." : <button className="btn btn-success"> Download PDF <FontAwesomeIcon icon={faPrint} /></button>
                                        }
                                    </PDFDownloadLink>
                                </div>
                                <div className='col-1'>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <PDFViewer style={{ width: "100%", height: "90vh" }}>
                                            <PDFQuotations data={quotationData} />
                                        </PDFViewer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;